import React from "react";
import "./MessageModal.css";

const InboxGenie = ({ show, onClose, last_updated, naukri_content }) => {
    if (!show || !naukri_content || naukri_content.length === 0) return null;

    const data = naukri_content[0]; // Assuming the first object contains relevant data
    const keys = Object.keys(data); // Extract keys dynamically

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal-content">
                <h2>Inbox Genie Summary <span className="text-sm">Last Updated: {last_updated}</span></h2>
                <table className="custom-table">
                    <thead>
                        <tr>
                            {keys.map((key) => (
                                <th key={key}>{key.charAt(0).toUpperCase() + key.slice(1)}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {keys.map((key) => (
                                <td key={key}>{data[key]}</td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                <div className="custom-modal-buttons">
                    <button className="custom-cancel-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default InboxGenie;
